import React from 'react'
import Login from '../../Auth/Login'
import './Navbar.css'

function Navbar(props) {
    return (
        <nav className="navbar navbar-expand-lg find-league-navbar navbar-light bg-light bg-opacity-50">
            <div className="container-fluid">
                <a className="navbar-brand" href="#">
                    <img src="https://bowl.com/bowl/images/usbclogo.svg" alt="United States Bowling Congress Logo" className="d-inline-block align-text-bottom" height={64} width={64} />
                    <span className='header'>USBC Leagues</span>
                </a>
               
                <Login></Login>
            </div>
        </nav>
    )
}

export default Navbar
